export const blockIconsAudioandvideoSkipNextNew = (
	<span className='material-symbols-outlined'>skip_next</span>
);
